import * as React from "react";

import { Button, Card, Collapse, H5, UL } from "@blueprintjs/core";
import { css } from "glamor";

import FightOverview from "src/FightRoom/FightOverview";
import { Fight } from "src/Interfaces";

const styles = {
	element: css({
		minWidth: "300px",
		flexBasis: "500px",
		margin: "10px",
		flexGrow: 1,
	}),
	jurorButton: css({ marginTop: "20px" }),
	jurorListElement: css({ textAlign: "left" }),
};

export default class FightPlanCard extends React.Component<
	{ fight: Fight; showJurors: boolean; onToggleShowJurors: (fight_id: number) => void },
	{}
> {
	public render() {
		const { fight, showJurors, onToggleShowJurors } = this.props;
		return (
			<div key={fight.id} {...styles.element}>
				<Card>
					<H5>{fight.name}</H5>
					<FightOverview
						teams={fight.teams}
						participants={fight.participants}
						stages={fight.stages}
						currentstage={-1}
					/>
					<div>
						<Button onClick={() => onToggleShowJurors(fight.id)} {...styles.jurorButton}>
							{showJurors}
							Jurors
						</Button>
						<Collapse keepChildrenMounted={true} isOpen={showJurors}>
							<UL>
								{Object.values(fight.jurors)
									.sort((a, b) => a.position - b.position)
									.map((juror) => (
										<li key={juror.id} {...styles.jurorListElement}>
											{juror.firstname + " " + juror.lastname}
										</li>
									))}
							</UL>
						</Collapse>
					</div>
				</Card>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Public/FightPlanCard.tsx